import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid}>
          {/* Brand */}
          <div>
            <h3 style={styles.logo}>Empire1Tires</h3>
            <p style={styles.about}>
              New York city's trusted mobile tire service. We come to you,
              at home, at work, or on the roadside. Fast, affordable,
              and available 24/7.
            </p>
            <div style={styles.socialRow}>
              <button style={styles.socialIcon}>📘</button>
              <button style={styles.socialIcon}>📸</button>
              <button style={styles.socialIcon}>💬</button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={styles.heading}>Quick Links</h4>
            <div style={styles.links}>
              {[
                { label: 'Home', id: 'home' },
                { label: 'Tire Finder', id: 'finder' },
                { label: 'Products', id: 'products' },
                { label: 'Services', id: 'services' },
                { label: 'Contact', id: 'contact' },
              ].map(item => (
                <button key={item.id} style={styles.linkBtn} onClick={() => scrollTo(item.id)}>
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={styles.heading}>Our Services</h4>
            <div style={styles.links}>
              <Link style={styles.link} to="/service-booking">Mobile Tire Change</Link>
              <Link style={styles.link} to="/service-booking">Used Tire Replacement</Link>
              <Link style={styles.link} to="/service-booking">24/7 Emergency Service</Link>
              <Link style={styles.link} to="/service-booking">Affordable Used Tires</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={styles.heading}>Contact</h4>
            <p style={styles.contactText}>📍 Clark, New Jersey, NYC</p>
            <p style={styles.contactText}>📞 +1(845) 879-3936</p>
            <p style={styles.contactText}>📧 info@empire1tires.com</p>
            <p style={styles.contactText}>🕐 24/7 Emergency Available</p>
          </div>
        </div>

        <div style={styles.bottom}>
          <p style={styles.copyright}>© 2024 Empire1Tires. All rights reserved.</p>
          <p style={styles.copyright}>Fast • Affordable • Mobile Tire Service</p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: { background: '#1a3a5c', padding: '60px 20px 20px' },
  container: { maxWidth: '1200px', margin: '0 auto' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '40px', marginBottom: '40px' },
  logo: { color: '#c41e3a', fontSize: '22px', marginBottom: '12px' },
  about: { color: '#888', fontSize: '14px', lineHeight: 1.7, marginBottom: '16px' },
  socialRow: { display: 'flex', gap: '12px' },
  socialIcon: { fontSize: '22px', background: 'none', border: 'none', cursor: 'pointer' },
  heading: { color: '#fff', fontSize: '15px', fontWeight: 'bold', marginBottom: '16px' },
  links: { display: 'flex', flexDirection: 'column', gap: '10px' },
  linkBtn: { color: '#888', fontSize: '14px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', padding: 0 },
  link: { color: '#888', fontSize: '14px', textDecoration: 'none' },
  contactText: { color: '#888', fontSize: '14px', marginBottom: '8px' },
  bottom: { borderTop: '1px solid #2a4a6e', paddingTop: '20px', textAlign: 'center' },
  copyright: { color: '#555', fontSize: '13px', margin: '4px 0' }
};

export default Footer;